import Entities from 'STORE';
import { IPushNotification } from 'STORE/PushNotifications/PushNotifications.types';

import { onNotificationClose } from '../utils/onNotificationClose';
import { prepareNotificationOptions } from '../utils/prepareNotificationOptions';

export const handleDeleteGroup = (pushNotification: IPushNotification): void => {
  if (!pushNotification.group) {
    return;
  }

  const options = prepareNotificationOptions(pushNotification);

  const notification = new Notification(pushNotification.title || '', options);
  Entities.pushNotifications.clearNotificationsByGroupId(pushNotification.group);
  Entities.pushNotifications.addNotification(notification);
  notification.onclose = (): void => onNotificationClose(notification);
  notification.onerror = (): void => onNotificationClose(notification);
};
